// ADR-109 — تعریف مسیرهای این فیچر. ASSUMPTION: ترکیب دقیق در روتر اصلی
// پروژه (احتمالاً apps/web/src/routes یا مشابه) باید توسط Antigravity انجام شود.
import type { RouteObject } from "react-router-dom";
import { RemoteAssistInboxPage } from "./pages/RemoteAssistInboxPage";
import { RemoteAssistSessionPage } from "./pages/RemoteAssistSessionPage";

export const remoteAssistRoutes: RouteObject[] = [
  {
    path: "/remote-assist",
    element: <RemoteAssistInboxPage />,
  },
  {
    path: "/remote-assist/:sessionId",
    element: <RemoteAssistSessionPage />,
  },
];
